import getCountries from 'Country/api/getCountries';

const loadCountryOptions = async (signal, query, additionalProps = []) => {
	const response = await getCountries(signal, query, 'name,asc');
	const countries = response.data.content;

	return countries
		.filter(country => country.name && country.name !== '-')
		.map(country => ({
			value: country.id,
			label: country.name,
			...additionalProps.reduce((acc, prop) => {
				acc[prop] = country[prop];
				return acc;
			}, {}),
		}));
};

export default loadCountryOptions;
